<template>
  <div class="mb20">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="container mb9 mt6">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item><span @click="$router.go(0)" class="hover">{{
        $route.meta.title || "基础信息"
          }}</span></el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container gap20">
      <div class="line60 BGwhite part25 container-left">
        <div class="avatar">
          <img :src="userInfo.Avatar" :onerror="userError" />
        </div>
        <p class="nickName">{{ userInfo.NickName || "暂无昵称" }}</p>
        <div class="logOut-box">
          <el-button type="primary" class="logOut" @click="logOut">退出登录</el-button>
        </div>

        <ul class="my-menu">
          <li v-for="(item, index) in menuList" :key="index">
            <div v-if="!item.isHidden" class="Conhover" :class="{
              Con3: item.active == true,
            }" @click="changeView(index, item)">
              <img :src="item.active == true ? item.activeImg : item.img" alt="" class="img" />
              <span class="title"> {{ item.title }}</span><img v-if="item.children && item.children.length > 0"
                :class="item.more ? 'icon1' : 'icon2'" :src="item.more
                  ? require('@/assets/img/member/26.png')
                  : require('@/assets/img/member/27.png')
                  " />
            </div>
            <div v-if="item.more">
              <div v-for="(child, idx) in item.children" class="child" :class="{
                Con2: $route.path == child.path || child.active == true,
              }" :key="idx" @click="changeChildView(index, child)">
                {{ child.title }}
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="view">
        <router-view v-if="updateViewStatus" @update="getUserInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import { GetUserInfo } from "@/api/member";
import { getToken, setToken, removeToken } from "@/util/auth";
export default {
  name: "demo",
  data() {
    return {
      userInfo: {},
      menuList: [
        {
          title: null,
          path: null,
        },
      ],
      updateViewStatus: true,
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (val) {
          this.init2();
          this.getUserInfo()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    logOut() {
      this.$store.state.userInfo = {};
      location.replace(location.pathname);
      localStorage.removeItem("ShareAuthKey");
      removeToken("Token");
      this.isLogin = false;
    },
    init2() {
      this.menuList.forEach((item) => {
        item.more = false;
        item.active = false;
        if (item.activePath && item.activePath.includes(this.$route.path)) {
          item.more = true;
          item.active = true;
        }
        if (item.children) {
          item.children.map((cd) => {
            cd.active = false;
            if (cd.activePath && cd.activePath.includes(this.$route.path)) {
              cd.active = true;
            }
          });
        }
      });
    },
    changeView(index, data) {
      if (data.children && data.children.length > 0) {
        this.menuList[index].more = !this.menuList[index].more;
        data.children.map((cd) => {
          cd.active = false;
          if (cd.activePath && cd.activePath.includes(this.$route.path)) {
            cd.active = true;
          }
        });
      } else {
        this.menuList.map((item) => {
          // item.more = false;
          item.active = false;
        });
        this.menuList[index].active = !this.menuList[index].active;
        this.$router.push({ path: data.path });
      }
    },
    changeChildView(index, data) {
      this.menuList.map((item) => {
        // item.more = false;
        item.active = false;
      });
      this.menuList[index].more = true;
      this.menuList[index].active = true;
      this.$router.push({ path: data.path });
    },

    getUserInfo() {
      GetUserInfo().then((res) => {
        // res.data.Avatar = this.webUrl + data.Avatar;
        console.log('getUserInfo', res)
        this.$store.state.userInfo = {
          ...this.$store.state.userInfo,
          ...res.data,
        };
        this.userInfo = res.data;
        this.init();
      });
    },
    init() {
      const IsManager = this.userInfo.IsManager;
      const arr = [
        {
          title: "用户信息",
          more: true,
          active: false,
          activePath: [
            "/member/info",
            "/member/account",
            "/member/editPassword",
            "/member/editPhone",
          ],
          img: require("@/assets/img/member/25.png"),
          activeImg: require("@/assets/img/member/11.png"),
          children: [
            {
              title: "基础信息",
              path: "info",
            },
            {
              title: "账号安全",
              path: "account",
              activePath: ["/member/editPassword", "/member/editPhone"],
            },
          ],
        },
        {
          title: "我的课程",
          active: false,
          activePath: ["/member/course"],
          img: require("@/assets/img/member/28.png"),
          activeImg: require("@/assets/img/member/12.png"),
          path: "course",
        },
        {
          title: "我的资料",
          active: false,
          activePath: ["/member/material"],
          img: require("@/assets/img/member/29.png"),
          activeImg: require("@/assets/img/member/13.png"),
          path: "material",
        },
        {
          title: "我的练习",
          more: false,
          active: false,
          activePath: ["/member/exerList", "/member/wrongList"],
          img: require("@/assets/img/member/30.png"),
          activeImg: require("@/assets/img/member/14.png"),
          children: [
            {
              title: "练习列表",
              path: "exerList",
            },
            {
              title: "错题集",
              path: "wrongList",
            },
          ],
        },
        {
          title: "我的收藏",
          more: false,
          active: false,
          activePath: [
            "/member/courseCollection",
            "/member/materialCollection",
            "/member/exerCollection",
          ],
          img: require("@/assets/img/member/39.png"),
          activeImg: require("@/assets/img/member/40.png"),
          children: [
            {
              title: "课程",
              path: "courseCollection",
            },
            {
              title: "资料",
              path: "materialCollection",
            },
            {
              title: "题库",
              path: "exerCollection",
            },
          ],
        },
        {
          title: "我的报名",
          active: false,
          activePath: ["/member/application"],
          img: require("@/assets/img/member/1.png"),
          activeImg: require("@/assets/img/member/15.png"),
          path: "application",
        },
        {
          title: "我的证书",
          active: false,
          activePath: ["/member/cert", "/member/certDetail"],
          img: require("@/assets/img/member/2.png"),
          activeImg: require("@/assets/img/member/16.png"),
          path: "cert",
        },
        {
          title: "考证目标",
          active: false,
          activePath: ["/member/certTarget"],
          img: require("@/assets/img/member/3.png"),
          activeImg: require("@/assets/img/member/17.png"),
          path: "certTarget",
        },
        {
          title: "我的考证",
          active: false,
          activePath: ["/member/myCert"],
          img: require("@/assets/img/member/4.png"),
          activeImg: require("@/assets/img/member/18.png"),
          path: "myCert",
        },
        {
          title: "我的订单",
          active: false,
          activePath: [
            "/member/order",
            "/member/orderDetail",
            "/member/billing",
            "/member/applyInvoicing",
          ],
          img: require("@/assets/img/member/5.png"),
          activeImg: require("@/assets/img/member/19.png"),
          children: [
            {
              title: "订单列表",
              path: "order",
              activePath: ["/member/orderDetail"],
            },
            {
              title: "我的开票",
              path: "billing",
              activePath: ["/member/applyInvoicing"],
            },
          ],
        },
        {
          title: "我的班级",
          active: false,
          activePath: ["/member/task", "/member/taskDetail"],
          img: require("@/assets/img/member/6.png"),
          activeImg: require("@/assets/img/member/20.png"),
          path: "task",
        },
        {
          title: "营销管理",
          path: "study",
          more: false,
          active: false,
          activePath: ["/member/distribution", "/member/dividends", "/member/finance"],
          img: require("@/assets/img/member/7.png"),
          activeImg: require("@/assets/img/member/21.png"),
          children: [
            {
              title: "分销记录",
              path: "distribution",
            },
            {
              title: "分红记录",
              path: "dividends",
            },
            {
              title: "提现记录",
              path: "finance",
            },
          ],
        },
        {
          title: "消息通知",
          active: false,
          activePath: ["/member/msg"],
          img: require("@/assets/img/member/8.png"),
          activeImg: require("@/assets/img/member/22.png"),
          path: "msg",
        },
        {
          title: "投诉建议",
          active: false,
          activePath: ["/member/suggestion"],
          img: require("@/assets/img/member/9.png"),
          activeImg: require("@/assets/img/member/23.png"),
          path: "suggestion",
        },
        {
          title: "单位管理",
          more: false,
          active: false,
          isHidden: true,
          activePath: [
            "/member/userList",
            "/member/studyRecord",
            "/member/certificate",
            "/member/taskLedger",
            "/member/taskLedgerDetail",
            "/member/userTaskProgress",
          ],
          img: require("@/assets/img/member/10.png"),
          activeImg: require("@/assets/img/member/24.png"),
          children: [
            {
              title: "人员列表",
              path: "userList",
              activePath: ["/member/studyRecord", "/member/certificate"],
            },
            {
              title: "班级台账",
              path: "taskLedger",
              activePath: [
                "/member/taskLedgerDetail",
                "/member/userTaskProgress",
              ],
            },
          ],
        },
      ];
      arr.map((item) => {
        if (item.title === "单位管理") {
          item.isHidden = IsManager == true ? false : true;
        }
        item.more = false;
        item.active = false;
        if (item.activePath && item.activePath.includes(this.$route.path)) {
          item.more = true;
          item.active = true;
        }
        if (item.children) {
          item.children.map((cd) => {
            cd.active = false;
            cd.path = `/member/${cd.path}`;
            if (cd.activePath && cd.activePath.includes(this.$route.path)) {
              cd.active = true;
            }
          });
        } else {
          item.path = `/member/${item.path}`;
        }
      });

      this.menuList = arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.gap20 {
  gap: 20px;
}

.view {
  width: 1420px;
}

.container {
  display: flex;

  .container-left {
    padding: 10px;
    width: 320px;
    min-height: 1241px;
    border-radius: 10px;

    .avatar {
      width: 110px;
      height: 110px;
      margin: 20px auto;
      margin-bottom: 0px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .nickName {
      margin: 10px 0;
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
      color: #333333;
    }

    .my-menu {
      margin-left: 15px;
    }

    .Conhover {
      display: flex;
      align-items: center;
      gap: 10px;

      .img {
        width: 22px;
        height: 20px;
      }

      .title {
        flex: 1;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
      }

      .icon1 {
        width: 8px;
        height: 6px;
        color: #333333;
        margin-top: -2px;
        margin-right: 20px;
      }

      .icon2 {
        width: 6px;
        height: 8px;
        color: #333333;
        margin-top: -2px;
        margin-right: 20px;
      }

      &:hover {
        .title {
          color: #1d79ff !important;
        }
      }
    }

    .child {
      cursor: pointer;
      margin-left: 20px;
      padding: 0 35px;
      margin-top: 1px;
      height: 48px;
      line-height: 48px;
      background: #f6f8fc;
      border-radius: 6px;
      font-size: 16px;
      color: #666666;
      position: relative;

      &::after {
        position: absolute;
        left: 20px;
        top: 22px;
        width: 4px;
        height: 4px;
        background: #999999;
        border-radius: 50%;
        content: "";
      }

      &:hover {
        color: #1d79ff !important;
      }
    }

    .Con2 {
      color: #1d79ff;

      &::after {
        position: absolute;
        left: 20px;
        top: 22px;
        width: 4px;
        height: 4px;
        background: #1d79ff;
        border-radius: 50%;
        content: "";
      }
    }

    .Con3 {
      .title {
        color: #1d79ff;
      }
    }
  }
}

.logOut-box {
  text-align: center;
}

.logOut {
  width: 144px;
  height: 52px;
  margin: 0 auto;
  font-size: 18px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
